<template>
  <img src="~/assets/icon/icon-trashbin.svg" />
</template>
